import { Controller } from "@hotwired/stimulus"

// This controller is used to update the favorite status of a leads list.
export default class extends Controller {
  static get targets() {
    return ["container"]
  }

  static get values() {
    return { isFavorite: Boolean, id: Number, greyStar: { type: Boolean, default: true } }
  }

  // This function is triggered using stimulus actions to update the favorite status of a leads list.
  toggleFavorite() {
    var method = "POST"
    const currentTooltip = bootstrap.Tooltip.getOrCreateInstance(this.containerTarget.querySelector(".fa-star"))

    if (this.isFavoriteValue) {
      method = "DELETE"
    }

    fetch(`/leads-lists/${this.idValue}/favorite`, {
      credentials: "same-origin",
      method: method,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      }
    }).then(response => {
      if (response.status === 201) {
        currentTooltip.dispose()
        this.containerTarget.innerHTML = `<div class='fas fa-star dark-orange' data-controller='tooltip' title="${i18n.t("js.back.leads_list.favorite.remove")}"></div>`
        this.isFavoriteValue = true
        App.displayFlash("success", i18n.t("js.back.leads_list.favorite.added"))
        return
      } else if (response.status === 204) {
        currentTooltip.dispose()
        let greyStyle = this.greyStarValue ? "grey" : ""
        this.containerTarget.innerHTML = `<div class='far fa-star ${greyStyle}' data-controller='tooltip' title="${i18n.t("js.back.leads_list.favorite.add")}"></div>`
        this.isFavoriteValue = false
        App.displayFlash("success", i18n.t("js.back.leads_list.favorite.removed"))
        return
      }

      App.displayFlash("danger", i18n.t("js.back.leads_list.favorite.error"))
    })
  }
}
